import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#9acd32', // A
          'primary-darken1': '#31a10b', // R
          'primary-lighten1': '#eafcc5', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#adff2f', // B
          'secondary-darken1': '#82d404', // D
          secondaryBtnText: '#424242', // B'
          headerBack: '#FFFFFF', // E
          headerText: '#424242', // F
          logoutBtnText: '#424242', // G
          topSchoolNamePc: '#9acd32', // H
          topSecondaryBtn: '#adff2f', // I
          topSecondaryBtnText: '#424242', // J
          topPrimaryBtn: '#9acd32', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#9acd32', // N
          secondaryOutLineBtnText: '#424242', // O
          topBtnUpTextSp: '#9acd32', // P
          topBtnBackSp: '#FFFFFF', // Q'
          eventHeaderBack: '#E7EFFF',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#9acd32',
          accent: '#9acd32', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
